import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SkeletonCircle, SkeletonLine } from './Skeleton';

const ServiceCardSkeleton = ({ className }) => {
	return (
		<div
			className={classNames(
				'rounded-3 p-3 border',
				'bg-gray-200 dark:bg-gray-700 animate-pulse',
				className,
			)}>
			<div className='d-flex align-items-start gap-3'>
				<SkeletonCircle size='3.25rem' />
				<div className='flex-grow-1'>
					<SkeletonLine width='72%' height='1rem' />
					<SkeletonLine className='mt-2' width='48%' height='0.8rem' />
				</div>
			</div>
			<div className='mt-3'>
				<SkeletonLine width='100%' height='10rem' rounded='lg' />
			</div>
			<div className='d-flex align-items-center justify-content-between mt-3'>
				<SkeletonLine width='36%' height='0.9rem' />
				<SkeletonLine width='28%' height='0.9rem' rounded='pill' />
			</div>
		</div>
	);
};

ServiceCardSkeleton.propTypes = {
	className: PropTypes.string,
};

ServiceCardSkeleton.defaultProps = {
	className: null,
};

export default ServiceCardSkeleton;
